<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4371"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4375"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4417"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4415" /></clipPath></defs><g
     id="g4377"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4379"
       transform="translate(140.9756,342.6289)"><path
         d="m 0,0 12.849,-8.294 30.45,27.779"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4381" /></g><g
       id="g4383"
       transform="translate(216.1592,348.2246)"><path
         d="M 0,0 H 106.505"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4385" /></g><g
       id="g4387"
       transform="translate(216.1592,281.334)"><path
         d="M 0,0 H 106.505"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4389" /></g><g
       id="g4391"
       transform="translate(216.1592,214.4424)"><path
         d="M 0,0 H 86.992"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4393" /></g><g
       id="g4395"
       transform="translate(216.1592,147.5234)"><path
         d="M 0,0 H 32.728"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4397" /></g><g
       id="g4399"
       transform="translate(140.9756,280.8838)"><path
         d="m 0,0 12.849,-8.267 30.45,27.781"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4401" /></g><g
       id="g4403"
       transform="translate(140.9756,219.166)"><path
         d="m 0,0 12.849,-8.294 30.45,27.779"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4405" /></g><g
       id="g4407"
       transform="translate(140.9756,157.4492)"><path
         d="m 0,0 12.849,-8.295 30.45,27.78"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path4409" /></g><g
       id="g4411"><g
         id="g4413"
         clip-path="url(#clipPath4417)"><g
           id="g4419"
           transform="translate(394.5303,117.5508)"><path
             d="m 0,0 h 15.576 c 1.715,0 3.121,-1.406 3.121,-3.121 v -30.788 c 0,-1.715 -1.406,-3.121 -3.121,-3.121 H 0 -4.162 c -2.418,0 -4.414,-1.969 -4.414,-4.387 v -4.189 -15.577 c 0,-1.715 -1.405,-3.093 -3.093,-3.093 h -30.815 c -1.715,0 -3.093,1.378 -3.093,3.093 v 15.577 4.189 c 0,2.418 -1.996,4.387 -4.414,4.387 h -4.19 -15.548 c -1.715,0 -3.122,1.406 -3.122,3.121 v 30.788 c 0,1.715 1.407,3.121 3.122,3.121 h 15.548 4.19 c 2.418,0 4.414,1.968 4.414,4.387 v 4.189 15.576 c 0,1.716 1.378,3.094 3.093,3.094 h 30.815 c 1.688,0 3.093,-1.378 3.093,-3.094 V 8.576 4.387 C -8.576,1.968 -6.58,0 -4.162,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4421" /></g><g
           id="g4423"
           transform="translate(149.5229,467.4131)"><path
             d="m 0,0 c 0,2.952 2.418,5.371 5.37,5.371 h 29.888 c 1.237,0 0.984,-0.197 1.49,0.871 2.587,5.37 6.129,10.404 10.6,14.874 10.628,10.656 24.602,15.971 38.548,15.971 13.974,0 27.92,-5.315 38.575,-15.971 4.471,-4.47 7.986,-9.504 10.572,-14.874 0.535,-1.068 0.282,-0.871 1.491,-0.871 h 29.916 c 2.924,0 5.342,-2.419 5.342,-5.371 v -24.434 -24.433 c 0,-2.925 -2.418,-5.343 -5.342,-5.343 H 5.37 c -2.952,0 -5.37,2.418 -5.37,5.343 v 24.433 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4425" /></g><g
           id="g4427"
           transform="translate(321.3145,424.6475)"><path
             d="m 0,0 h 52.016 c 2.671,0 4.864,-2.165 4.864,-4.837 v -229.857 m -285.523,42.934 V -4.837 c 0,2.672 2.165,4.837 4.836,4.837 h 52.015 m 129.111,-347.811 h -181.126 c -2.671,0 -4.836,2.165 -4.836,4.836 v 116.856"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4429" /></g><g
           id="g4431"
           transform="translate(300.002,37.1641)"><path
             d="m 0,0 h -232.242 c -8.125,0 -14.761,6.636 -14.761,14.761 v 397.634 c 0,8.126 6.636,14.761 14.761,14.761 h 81.763 M 117.864,252.127 V 138.28 M 21.312,427.156 h 81.763 c 8.126,0 14.789,-6.635 14.789,-14.761 V 286.486"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4433" /></g><g
           id="g4435"
           transform="translate(367.4541,7.5)"><path
             d="m 0,0 c 50.412,0 91.547,41.107 91.547,91.55 0,50.414 -41.135,91.521 -91.547,91.521 -50.413,0 -91.548,-41.107 -91.548,-91.521 C -91.548,41.107 -50.413,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4437" /></g></g></g></g></svg>
</template>
